/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      name
      subline
      description
      colour
      icon
      careers {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      video
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $id: ID
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCategories(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCategoriesByName = /* GraphQL */ `
  query ListCategoriesByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCareer = /* GraphQL */ `
  query GetCareer($id: ID!) {
    getCareer(id: $id) {
      id
      name
      description
      categoryID
      archive
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      video
      relatedCareersBridges {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCareers = /* GraphQL */ `
  query ListCareers(
    $id: ID
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCareers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const careersByName = /* GraphQL */ `
  query CareersByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careersByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const careersByCategoryIDAndName = /* GraphQL */ `
  query CareersByCategoryIDAndName(
    $categoryID: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careersByCategoryIDAndName(
      categoryID: $categoryID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCareersByName = /* GraphQL */ `
  query ListCareersByName(
    $t: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCareersByName(
      t: $t
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRelatedCareer = /* GraphQL */ `
  query GetRelatedCareer($id: ID!) {
    getRelatedCareer(id: $id) {
      id
      type
      name
      description
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRelatedCareers = /* GraphQL */ `
  query ListRelatedCareers(
    $filter: ModelRelatedCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelatedCareers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRelatedCareersByName = /* GraphQL */ `
  query ListRelatedCareersByName(
    $type: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRelatedCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelatedCareersByName(
      type: $type
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const relatedCareersByName = /* GraphQL */ `
  query RelatedCareersByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRelatedCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    relatedCareersByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRelatedCareersByVersion = /* GraphQL */ `
  query ListRelatedCareersByVersion(
    $version: Int!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRelatedCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelatedCareersByVersion(
      version: $version
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuestion = /* GraphQL */ `
  query GetQuestion($id: ID!) {
    getQuestion(id: $id) {
      id
      description
      categoryID
      type
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      set
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQuestions = /* GraphQL */ `
  query ListQuestions(
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestionsByCategoryID = /* GraphQL */ `
  query ListQuestionsByCategoryID(
    $categoryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionsByCategoryID(
      categoryID: $categoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const questionsByCategoryBySet = /* GraphQL */ `
  query QuestionsByCategoryBySet(
    $categoryID: ID!
    $set: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    questionsByCategoryBySet(
      categoryID: $categoryID
      set: $set
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const questionsByCategoryByNumber = /* GraphQL */ `
  query QuestionsByCategoryByNumber(
    $categoryID: ID!
    $number: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    questionsByCategoryByNumber(
      categoryID: $categoryID
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestionsBySetByNumber = /* GraphQL */ `
  query ListQuestionsBySetByNumber(
    $set: Int!
    $number: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionsBySetByNumber(
      set: $set
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestionsBySet = /* GraphQL */ `
  query ListQuestionsBySet(
    $t: String!
    $set: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionsBySet(
      t: $t
      set: $set
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestionsByNumber = /* GraphQL */ `
  query ListQuestionsByNumber(
    $t: String!
    $number: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionsByNumber(
      t: $t
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestionsByDescription = /* GraphQL */ `
  query ListQuestionsByDescription(
    $t: String!
    $description: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionsByDescription(
      t: $t
      description: $description
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestionsByVersion = /* GraphQL */ `
  query ListQuestionsByVersion(
    $t: String!
    $version: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionsByVersion(
      t: $t
      version: $version
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRelatedCareersBridge = /* GraphQL */ `
  query GetRelatedCareersBridge($id: ID!) {
    getRelatedCareersBridge(id: $id) {
      id
      careerID
      relatedCareerID
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      relatedCareer {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRelatedCareersBridges = /* GraphQL */ `
  query ListRelatedCareersBridges(
    $id: ID
    $filter: ModelRelatedCareersBridgeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRelatedCareersBridges(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        careerID
        relatedCareerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRelatedCareersBridgesByCareerId = /* GraphQL */ `
  query ListRelatedCareersBridgesByCareerId(
    $careerID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRelatedCareersBridgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelatedCareersBridgesByCareerId(
      careerID: $careerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        careerID
        relatedCareerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStudent = /* GraphQL */ `
  query GetStudent($id: ID!) {
    getStudent(id: $id) {
      id
      userID
      username
      name
      surname
      age
      email
      phone_number
      gradeID
      schoolID
      grade {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      school {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      sponsors {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStudents = /* GraphQL */ `
  query ListStudents(
    $id: ID
    $filter: ModelStudentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStudents(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStudentsByUserId = /* GraphQL */ `
  query ListStudentsByUserId(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStudentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentsByUserId(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStudentsByGradeId = /* GraphQL */ `
  query ListStudentsByGradeId(
    $gradeID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStudentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentsByGradeId(
      gradeID: $gradeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStudentsBySchoolId = /* GraphQL */ `
  query ListStudentsBySchoolId(
    $schoolID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStudentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentsBySchoolId(
      schoolID: $schoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGrade = /* GraphQL */ `
  query GetGrade($id: ID!) {
    getGrade(id: $id) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGrades = /* GraphQL */ `
  query ListGrades(
    $id: ID
    $filter: ModelGradeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGrades(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const gradeByName = /* GraphQL */ `
  query GradeByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelGradeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gradeByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSchool = /* GraphQL */ `
  query GetSchool($id: ID!) {
    getSchool(id: $id) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSchools = /* GraphQL */ `
  query ListSchools(
    $id: ID
    $filter: ModelSchoolFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSchools(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const schoolByName = /* GraphQL */ `
  query SchoolByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSchoolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    schoolByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSponsor = /* GraphQL */ `
  query GetSponsor($id: ID!) {
    getSponsor(id: $id) {
      id
      name
      logo
      license_count
      code
      content
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        phoneNumber
        emailAddress
        websiteURL
        __typename
      }
      students {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSponsors = /* GraphQL */ `
  query ListSponsors(
    $id: ID
    $filter: ModelSponsorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSponsors(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sponsorByName = /* GraphQL */ `
  query SponsorByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sponsorByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSponsorStudentBridge = /* GraphQL */ `
  query GetSponsorStudentBridge($id: ID!) {
    getSponsorStudentBridge(id: $id) {
      id
      sponsorID
      studentID
      code
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      result {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSponsorStudentBridges = /* GraphQL */ `
  query ListSponsorStudentBridges(
    $filter: ModelSponsorStudentBridgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSponsorStudentBridges(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSponsorStudentBridgesBySponsorId = /* GraphQL */ `
  query ListSponsorStudentBridgesBySponsorId(
    $sponsorID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorStudentBridgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSponsorStudentBridgesBySponsorId(
      sponsorID: $sponsorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSponsorStudentBridgesByStudentId = /* GraphQL */ `
  query ListSponsorStudentBridgesByStudentId(
    $studentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorStudentBridgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSponsorStudentBridgesByStudentId(
      studentID: $studentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSponsorStudentBridgesByCode = /* GraphQL */ `
  query ListSponsorStudentBridgesByCode(
    $code: String!
    $sponsorID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorStudentBridgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSponsorStudentBridgesByCode(
      code: $code
      sponsorID: $sponsorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResults = /* GraphQL */ `
  query GetResults($id: ID!) {
    getResults(id: $id) {
      id
      studentID
      sponsorStudentBridgeID
      file
      progress
      expiryDate
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      responses {
        nextToken
        __typename
      }
      feedback {
        nextToken
        __typename
      }
      resultCategories {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResults = /* GraphQL */ `
  query ListResults(
    $id: ID
    $filter: ModelResultsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResults(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResultsByStudentId = /* GraphQL */ `
  query ListResultsByStudentId(
    $studentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelResultsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResultsByStudentId(
      studentID: $studentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResultsBySponsorStudentBridgeId = /* GraphQL */ `
  query ListResultsBySponsorStudentBridgeId(
    $sponsorStudentBridgeID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelResultsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResultsBySponsorStudentBridgeId(
      sponsorStudentBridgeID: $sponsorStudentBridgeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResultCategory = /* GraphQL */ `
  query GetResultCategory($id: ID!) {
    getResultCategory(id: $id) {
      id
      resultID
      score
      categoryID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResultCategories = /* GraphQL */ `
  query ListResultCategories(
    $filter: ModelResultCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResultCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        score
        categoryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResultCategoriesByResultId = /* GraphQL */ `
  query ListResultCategoriesByResultId(
    $resultID: ID!
    $score: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResultCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResultCategoriesByResultId(
      resultID: $resultID
      score: $score
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        score
        categoryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFeedbackQuestion = /* GraphQL */ `
  query GetFeedbackQuestion($id: ID!) {
    getFeedbackQuestion(id: $id) {
      id
      description
      type
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFeedbackQuestions = /* GraphQL */ `
  query ListFeedbackQuestions(
    $id: ID
    $filter: ModelFeedbackQuestionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFeedbackQuestions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        description
        type
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedbackQuestionsByNumber = /* GraphQL */ `
  query FeedbackQuestionsByNumber(
    $number: Int!
    $t: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedbackQuestionsByNumber(
      number: $number
      t: $t
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        type
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      resultID
      feedbackQuestionID
      sponsorID
      studentID
      feedback
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      feedbackQuestion {
        id
        description
        type
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $id: ID
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFeedbacks(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        resultID
        feedbackQuestionID
        sponsorID
        studentID
        feedback
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFeedbacksByResultId = /* GraphQL */ `
  query ListFeedbacksByResultId(
    $resultID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacksByResultId(
      resultID: $resultID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        feedbackQuestionID
        sponsorID
        studentID
        feedback
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFeedbacksBySponsorId = /* GraphQL */ `
  query ListFeedbacksBySponsorId(
    $sponsorID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacksBySponsorId(
      sponsorID: $sponsorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        feedbackQuestionID
        sponsorID
        studentID
        feedback
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFeedbacksByStudentId = /* GraphQL */ `
  query ListFeedbacksByStudentId(
    $studentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacksByStudentId(
      studentID: $studentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        feedbackQuestionID
        sponsorID
        studentID
        feedback
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResponse = /* GraphQL */ `
  query GetResponse($id: ID!) {
    getResponse(id: $id) {
      id
      resultID
      questionID
      studentID
      sponsorStudentBridgeID
      response
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      question {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResponses = /* GraphQL */ `
  query ListResponses(
    $id: ID
    $filter: ModelResponseFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResponses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        resultID
        questionID
        studentID
        sponsorStudentBridgeID
        response
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResponsesByResultId = /* GraphQL */ `
  query ListResponsesByResultId(
    $resultID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResponsesByResultId(
      resultID: $resultID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        questionID
        studentID
        sponsorStudentBridgeID
        response
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bySponsorStudentBridge = /* GraphQL */ `
  query BySponsorStudentBridge(
    $sponsorStudentBridgeID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bySponsorStudentBridge(
      sponsorStudentBridgeID: $sponsorStudentBridgeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        questionID
        studentID
        sponsorStudentBridgeID
        response
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSponsorCode = /* GraphQL */ `
  query GetSponsorCode($id: ID!) {
    getSponsorCode(id: $id) {
      id
      sponsorID
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      code
      paymentID
      used
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSponsorCodes = /* GraphQL */ `
  query ListSponsorCodes(
    $id: ID
    $filter: ModelSponsorCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSponsorCodes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sponsorID
        code
        paymentID
        used
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSponsorCodesBySponsor = /* GraphQL */ `
  query ListSponsorCodesBySponsor(
    $sponsorID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSponsorCodesBySponsor(
      sponsorID: $sponsorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        code
        paymentID
        used
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSponsorCodesBySponsorIdByUsedByCode = /* GraphQL */ `
  query ListSponsorCodesBySponsorIdByUsedByCode(
    $sponsorID: ID!
    $usedCode: ModelSponsorCodeBySponsorByUsedByCodeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSponsorCodesBySponsorIdByUsedByCode(
      sponsorID: $sponsorID
      usedCode: $usedCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        code
        paymentID
        used
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const byCode = /* GraphQL */ `
  query ByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        code
        paymentID
        used
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const byUsed = /* GraphQL */ `
  query ByUsed(
    $used: String!
    $t: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSponsorCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byUsed(
      used: $used
      t: $t
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sponsorID
        code
        paymentID
        used
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFavouritedCareer = /* GraphQL */ `
  query GetFavouritedCareer($id: ID!) {
    getFavouritedCareer(id: $id) {
      id
      resultID
      careerID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFavouritedCareers = /* GraphQL */ `
  query ListFavouritedCareers(
    $id: ID
    $filter: ModelFavouritedCareerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFavouritedCareers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        resultID
        careerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFavouritedCareersByResult = /* GraphQL */ `
  query ListFavouritedCareersByResult(
    $resultID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFavouritedCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFavouritedCareersByResult(
      resultID: $resultID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resultID
        careerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCareerCentre = /* GraphQL */ `
  query GetCareerCentre($id: ID!) {
    getCareerCentre(id: $id) {
      id
      name
      description
      image
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        name
        phoneNumber
        phoneNumber2
        emailAddress
        websiteURL
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCareerCentres = /* GraphQL */ `
  query ListCareerCentres(
    $id: ID
    $filter: ModelCareerCentreFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCareerCentres(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        image
        t
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
